// AnnualPolicy.jsx — self-contained page (no extra CSS file or libraries needed)
//
// 1. Put the 3 PDFs in your site's public folder, e.g. public/policy_docs/
// 2. Add a route to this page, e.g. /investors/policy
// 3. In your navbar: Investors (dropdown) -> "Policy" linking to that route
//
// New years: add an entry at the TOP of the list below.

const annualPolicy = [
  { title: "POSH Policy", period: "POSH Policy", file: "/policy_docs/POSH-Policy.pdf" },
  { title: "Code of Conduct Independent Directors", period: "Code of Conduct Independent Directors", file: "/policy_docs/Code_of_Conduct_Independent_Directors.pdf" },
  { title: "Corporate Social Responsibility Policy", period: "Corporate Social Responsibility Policy", file: "/policy_docs/Corporate_Social_Responsibility_Policy.pdf" },
  { title: "Whistle Blower Policy", period: "Whistle Blower Policy", file: "/policy_docs/Whistle_Blower_Policy.pdf" },

];

const css = `
.ar-page{max-width:900px;margin:0 auto;padding:48px 20px 64px;font-family:system-ui,-apple-system,"Segoe UI",Roboto,sans-serif;color:#1c2733}
.ar-crumb{color:#5b6b7b;font-size:.9rem;margin:0 0 6px}
.ar-page h1{margin:0 0 8px;color:#0f2a47;font-size:2rem}
.ar-lead{color:#5b6b7b;margin:0 0 28px}
.ar-list{list-style:none;margin:0;padding:0;display:grid;gap:14px}
.ar-card{display:flex;align-items:center;gap:16px;background:#fff;border:1px solid #dde3ea;border-radius:10px;padding:16px 20px;transition:box-shadow .15s,transform .15s}
.ar-card:hover{box-shadow:0 6px 18px rgba(15,42,71,.1);transform:translateY(-1px)}
.ar-icon{width:48px;height:56px;flex:none;display:grid;place-items:center;background:#fdecec;color:#c62828;font-weight:700;font-size:.8rem;border-radius:6px}
.ar-info{flex:1;min-width:0}
.ar-info h2{margin:0 0 4px;font-size:1.05rem;color:#0f2a47}
.ar-info span{color:#5b6b7b;font-size:.9rem}
.ar-actions{display:flex;gap:10px}
.ar-actions a{padding:8px 16px;border-radius:6px;font-size:.9rem;font-weight:600;border:1px solid #0f2a47;color:#0f2a47;text-decoration:none}
.ar-actions a:last-child{background:#0f2a47;color:#fff}
.ar-actions a:hover{filter:brightness(1.15)}
@media(max-width:600px){.ar-card{flex-wrap:wrap}.ar-actions{width:100%}}
`;

export default function AnnualPolicy() {
  return (
    <section className="ar-page">
      <style>{css}</style>
      <p className="ar-crumb">Investors / Policy</p>
      <h1>Policy</h1>
      <p className="ar-lead">
      
      </p>

      <ul className="ar-list">
        {annualPolicy.map((r) => (
          <li key={r.title} className="ar-card">
            <div className="ar-icon" aria-hidden="true">PDF</div>
            <div className="ar-info">
              <h2>{r.title}</h2>
              <span>{r.period}</span>
            </div>
            <div className="ar-actions">
              <a href={encodeURI(r.file)} target="_blank" rel="noopener noreferrer">View</a>
              <a href={encodeURI(r.file)} download>Download</a>
            </div>
          </li>
        ))}
      </ul>
    </section>
  );
}
